import { differenceInDays } from 'date-fns'

export const getCountDownNumber = (
  maxCount: number,
  startDate: Date | string,
  nowDate: Date | string,
  step: number = 1,
): number => {
  const start = new Date(startDate)
  const now = new Date(nowDate)

  const daysDifference = differenceInDays(now, start)
  const hourNow = now.getUTCHours()

  const countDifference =
    daysDifference * step + Math.ceil((hourNow * step) / 24)
  const count = maxCount - countDifference

  if (start > now) {
    return maxCount
  }

  if (count < 0) {
    return 0
  }

  return count
}
